import React, { useEffect, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import InvoiceListItem from "./elv_details/InvoiceListItem";


/**
 * 
 * @param {props} data array of object to display
 * @param {props} pdfReader function to show pdf in modal
 *  
 * @returns <ul> 
 */
const DetailedList = ({ data, pdfReader, type, preselect }) => {

    const maxItemsToDisplay = 5;
    const [showPagination, setShowPagination] = useState(false);
    const [displayedPage, setDisplayedPage] = useState(1);
    const [filteredData, setFilteredData] = useState([]);


    useEffect(() => {
        if (data && data.length > maxItemsToDisplay) {
            setShowPagination(true);
            setFilteredData(data.slice(0, maxItemsToDisplay))
        }
        else {
            setFilteredData(data);
            setShowPagination(false);
        }
    }, [data])


    const paginationPrevious = (e) => {
        e.preventDefault();
        setFilteredData(data.slice((displayedPage - 2) * maxItemsToDisplay, maxItemsToDisplay * (displayedPage - 1)));
        setDisplayedPage(prev => (prev - 1));
    }


    const paginationNext = (e) => {
        e.preventDefault();
        setFilteredData(data.slice(displayedPage * maxItemsToDisplay, maxItemsToDisplay * (displayedPage + 1)));
        setDisplayedPage(prev => (prev + 1));
    }


    return (
        <div key={`${type}-container`}>
            <ul className="detailed-list" key={`${type}-containingList`}>
                {filteredData && filteredData.length > 0 ?
                    filteredData.map(item =>
                         <InvoiceListItem
                            key={`item-${item.id}:${type}`}
                            type={type}
                            invoice={item}
                            pdfReader={pdfReader}
                            isSelected={preselect? preselect.type === type && preselect.id === item.id : null}
                        />
                    ) :
                    <small style={{ userSelect: "none" }} className="text-muted">Keine Dokumente</small>
                }
            </ul>
            {showPagination ?
                <div className="text-center mt-3">
                    {
                        displayedPage === 1 ?
                            <span style={{ color: "#c0c4c2" }}><FaChevronLeft /></span>
                            :
                            <a
                                href="/back"
                                onClick={e => paginationPrevious(e)}
                                className="link-energo"
                            >
                                <FaChevronLeft />
                            </a>
                    }
                    &nbsp;
                    {displayedPage} von {Math.ceil(data.length / maxItemsToDisplay)} &nbsp;
                    {
                        displayedPage === data.length / maxItemsToDisplay ?
                            <span style={{ color: "#c0c4c2" }}><FaChevronRight /></span>
                            :
                            <a href="/next" onClick={e => paginationNext(e)} className="link-energo"><FaChevronRight /></a>
                    }
                </div>
                : null}
        </div>
    )
}
export default DetailedList;